
export const SUBSITE = '/backend/'

//export const green = "#6bd086"
//export const green = "#75e98f"
export const green = '#aff3c4'
export const yellow = '#f3f4c2'
export const anxiety = '#dfe8ed'
export const orange = '#fcd4a3'
export const red = '#ff7a72'
//export const background = '#dde1dd'

export const dark = '#406878'
export const background = '#a0bcd0'
export const read_only_color = '#6f726f'


export const first = '#d9e7f8'
export const bad_first = '#d9c4f8'

export const second = '#ffffff'
export const bad_second = '#ffd1d3'

export const third = '#f7f8b9'
export const bad_third = '#f8d2a2'

// Home runs
export const state_colors = {
	'COMPLETED': '#68a5c5',
	'RUNNING': '#6ec5c2',
	'PLANNED': '#52a38a',
	'PLANNING': '#65c97a',
}

export function sum_reads(reads, explib) {
	return parseFloat(explib.target_reads_adjust) + reads
}

function sorting(f, s) {

	if (f < s) {
		return -1
	}
	else if (f > s) {
		return 1
	}
	else {
		return 0
	}
}

function by_panel(exp1, exp2) {
	let panel1 = exp1.library.ngs_appointment.panel
	let panel2 = exp2.library.ngs_appointment.panel
	return sorting(panel1, panel2)
}

function by_color(exp1, exp2) {
	let ngs_app1 = exp1.library.ngs_appointment.back_color
	let ngs_app2 = exp2.library.ngs_appointment.back_color
	return sorting(ngs_app1, ngs_app2)
}

function by_barcode(exp1, exp2) {
	//let bar1 = exp1.experiment.name
	//let bar2 = exp2.experiment.name
	let bar1 = exp1.library.barcode.index
	let bar2 = exp2.library.barcode.index
	return sorting(bar1, bar2)
}

export const sort_funcs = {
	"BY_PANEL": by_panel,
	"BY_COLOR": by_color,
	"BY_BARCODE": by_barcode
}

export const empty_run = {
	name: '',
	barcodes: {},
	explibs: {},
	barcode_set: '',
	dt: '',
	state: null,
	ngsExp_set: []
}


export const col_headers = ['Library', 'Lab', 'Panel', 'Sample<br>name', 'Sample<br>type', 'Patient',
	'Decision<br>date', 'Bar<br>code', //'Amplicons<br>length<br>bp',
	'Library<br>conc.<br>', //'Conc.<br>units',
	'Number of<br>amplicons', 'Required<br>coverage', 'Adjusting<br>Coef.',
	'Already<br>reads',
	'Reads<br>expected', 'ng/mL<br>100 pM', 'Conc.<br>coef.',
	'Notes']